import {captureMessage} from '@treatwell/ui/datadog';
import type {WafTokenState} from './wafToken';

export const WAF_TOKEN_MISSING_MESSAGE = 'waf_token_missing';

// Temporary: logged with the same ruid sent on the request, so it can be matched
// with the backend logs to find out why API requests go out without a WAF token.
export function logTokenlessRequest(
  state: WafTokenState,
  request: {ruid: string; method: string; path: string}
) {
  captureMessage(WAF_TOKEN_MISSING_MESSAGE, 'warn', {
    ruid: request.ruid,
    waf: state,
    request: {method: request.method, path: request.path.split('?')[0]},
  });
}
